/**
 * M1Sequence.tsx
 * Last updated: 2025-08-12 14:20:19
 * Updated by: JulianPolly
 */

import { M1InfoScreen } from "./M1InfoScreen";
import { ScreenSequence } from "../Sequences";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { useLanguage } from "../../../../context/LanguageContext";

export const M1SequenceKey = "M1Info";

// Original static sequence definition with hardcoded texts
export const M1Sequence: ScreenSequence = {
    name: "Wie Entscheidungen beeinflusst werden",
    description: "Auf dieser Materialseite findest du eine Einführung zum Thema Heuristiken und Biases, dem zentralen Konzept der Verhaltensökonomie.",
    group: "Material",
    screens: [
        {
            component: M1InfoScreen.component,
            canContinueDefault: M1InfoScreen.canContinueDefault,
            defaultResult: M1InfoScreen.defaultResult
        },
        {
            component: WellDoneScreen,
            canContinueDefault: false
        }
    ]
};

// Hook-based sequence creation for when we need translations
export function useM1Sequence(): ScreenSequence {
    const { t } = useLanguage();

    return {
        name: t('experiments', 'M1InfoScreen', 'sequence', 'name'),
        description: t('experiments', 'M1InfoScreen', 'sequence', 'description'),
        group: "Info",
        screens: [
            {
                component: M1InfoScreen.component,
                canContinueDefault: M1InfoScreen.canContinueDefault,
                defaultResult: M1InfoScreen.defaultResult
            },
            {
                component: WellDoneScreen,
                canContinueDefault: false
            }
        ]
    };
}